import React from 'react';
import { Screen } from 'src/components/screen';
import { CampaignsProvider, useCampaigns } from './campaigns-context';
import { ConfigurationPanel } from './components/configuration-panel';
import { PreviewPanel } from './components/preview-panel';
import { Box } from '@mui/material';
import { campaignsLayoutSx } from './styles';

// Inner component to access context
const CampaignsScreenInner: React.FC = () => {
  const { jsonOutput, loading, error } = useCampaigns();
  return (
    <Box sx={campaignsLayoutSx}>
      <ConfigurationPanel />
      {(jsonOutput || loading || error) && (
        <PreviewPanel result={jsonOutput} loading={loading} error={error} />
      )}
    </Box>
  );
};

const CampaignsScreen: React.FC = () => {
  return (
    <Screen>
      <CampaignsProvider>
        <CampaignsScreenInner />
      </CampaignsProvider>
    </Screen>
  );
};

export { CampaignsScreen };
